export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const DELETE_OBJECTS = 'DELETE_OBJECTS';
export const DELETE_OBJECTS_SUCCESS = 'DELETE_OBJECTS_SUCCESS';
export const DELETE_OBJECTS_FAILURE = 'DELETE_OBJECTS_FAILURE';

export const FILE_DOWNLOAD = 'FILE_DOWNLOAD';

export const FILE_UPLOAD = 'FILE_UPLOAD';

export const FILE_UPLOADING = 'FILE_UPLOADING';
export const FILE_UPLOADING_PROGRESS = 'FILE_UPLOADING_PROGRESS';
export const FILE_UPLOADING_CANCELLED = 'FILE_UPLOADING_CANCELLED';
export const FILE_UPLOADING_SUCCESS = 'FILE_UPLOADING_SUCCESS';
export const FILE_UPLOADING_FAILURE = 'FILE_UPLOADING_FAILURE';

export const GET_OBJECT = 'GET_OBJECT';
export const GET_OBJECT_SUCCESS = 'GET_OBJECT_SUCCESS';
export const GET_OBJECT_FAILURE = 'GET_OBJECT_FAILURE';

export const GET_OBJECT_DOWNLOAD = 'GET_OBJECT_DOWNLOAD';
export const GET_OBJECT_DOWNLOAD_SUCCESS = 'GET_OBJECT_DOWNLOAD_SUCCESS';
export const GET_OBJECT_DOWNLOAD_FAILURE = 'GET_OBJECT_DOWNLOAD_FAILURE';

export const GET_OBJECTS = 'GET_OBJECTS';
export const GET_OBJECTS_SUCCESS = 'GET_OBJECTS_SUCCESS';
export const GET_OBJECTS_FAILURE = 'GET_OBJECTS_FAILURE';

export const GET_DELETED_OBJECTS = 'GET_DELETED_OBJECTS';
export const GET_DELETED_OBJECTS_SUCCESS = 'GET_DELETED_OBJECTS_SUCCESS';
export const GET_DELETED_OBJECTS_FAILURE = 'GET_DELETED_OBJECTS_FAILURE';

export const INITIALIZE = 'INITIALIZE';
export const INITIALIZE_SUCCESS = 'INITIALIZE_SUCCESS';
export const INITIALIZE_FAILURE = 'INITIALIZE_FAILURE';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const RESTORE_OBJECTS = 'RESTORE_OBJECTS';
export const RESTORE_OBJECTS_SUCCESS = 'RESTORE_OBJECTS_SUCCESS';
export const RESTORE_OBJECTS_FAILURE = 'RESTORE_OBJECTS_FAILURE';

export const STAR_OBJECT = 'STAR_OBJECT';
export const STAR_OBJECT_SUCCESS = 'STAR_OBJECT_SUCCESS';
export const STAR_OBJECT_FAILURE = 'STAR_OBJECT_FAILURE';

export const UPDATE_OBJECT_NAME = 'UPDATE_OBJECT_NAME';
export const UPDATE_OBJECT_NAME_SUCCESS = 'UPDATE_OBJECT_NAME_SUCCESS';
export const UPDATE_OBJECT_NAME_FAILURE = 'UPDATE_OBJECT_NAME_FAILURE';

export const UNSTAR_OBJECT = 'UNSTAR_OBJECT';
export const UNSTAR_OBJECT_SUCCESS = 'UNSTAR_OBJECT_SUCCESS';
export const UNSTAR_OBJECT_FAILURE = 'UNSTAR_OBJECT_FAILURE';

export const SEARCH = 'SEARCH';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';

export const VERIFY_INITIALIZATION = 'VERIFY_INITIALIZATION';
export const VERIFY_INITIALIZATION_SUCCESS = 'VERIFY_INITIALIZATION_SUCCESS';
export const VERIFY_INITIALIZATION_FAILURE = 'VERIFY_INITIALIZATION_FAILURE';



// Local actions
export const CHECK_CHECKBOX = 'CHECK_CHECKBOX';
export const UNCHECK_CHECKBOX = 'UNCHECK_CHECKBOX';

export const CHECK_CHECKBOXES = 'CHECK_CHECKBOXES'
export const UNCHECK_CHECKBOXES = 'UNCHECK_CHECKBOXES'

export const CLEAR_SELECTIONS = 'CLEAR_SELECTIONS';

export const CLOSE_MODAL = 'CLOSE_MODAL';

export const SHOW_MODAL = 'SHOW_MODAL';